export enum EReservationType {
  RESERVATION = 'reservation',
  INQUIRY = 'inquiry',
  ICAL = 'ical',
}
